import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as PAYMENTACTIONS } from '../../store/actions/paymentActions';
import BundleCard from './BundleCard';
import AdvisorBundleCard from './AdvisorBundleCard';
import PaymentMethods from '../common/payments/PaymentMethods';
import PayAndRegister from '../common/payments/PayAndRegister';
import ReactDOM from "react-dom";
import { v4 as uuidv4 } from 'uuid';
import { XMarkIcon } from "@heroicons/react/20/solid";
import _ from "lodash";


const PaymentModal = ({
  getBundles,
  showModal,
  closeModal,
  selectBundle,
  bundles,
  advisorBundles,
  recommended,
  selectedBundle,
  creditsNeeded,
  isAdvisor,
  isDemo,
  isNew
}) => {

  useEffect(() => {
    getBundles()
  }, []);


  useEffect(() => {

    if (recommended) {
      // scroll to middle 
    }

  }, [recommended]);

  if (!showModal || !bundles) {
    return null
  }

  if (selectedBundle && (isDemo || isNew)) {
    return (
      <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{
        display: "block", background: "rgba(0,0,0,0.9)", overflow:
          "scroll"
      }}>
        <PayAndRegister />
      </div>
    )
  }

  if (selectedBundle) {
    return (
      <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{
        display: "block", background: "rgba(0,0,0,0.9)", overflow:
          "scroll"
      }}>
        <PaymentMethods />
      </div>
    )
  }

  const bundlesToUse = isAdvisor ? advisorBundles: bundles

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{
      display: "block", background: "rgba(0,0,0,0.9)", overflow:
        "scroll"
    }}>

      <div
        style={{
          color: "white",
          position: "absolute",
          top: 15,
          right: 15,
          cursor: "pointer",
        }}
        onClick={() => {
          localStorage.setItem('ignoreInsufficientCredits', new Date().getTime() + 2 * 60 * 60 * 1000)
          closeModal()
        }}>
        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
      </div>

      <section className="billing-page">
        <div
          style={{
            top: "50%",
            marginLeft: "10%",
            marginRight: "10%",
            width: '80%',
            transform: "translateY(-50%)",
            position: "absolute",
          }}>
          <div className={`grid grid-cols-${bundlesToUse.length} gap-8`}>
            {(bundlesToUse)?.map(bundle =>
              <BundleCard key={bundle.id} bundle={bundle} />
            )}
          </div>


          {/*{
            isAdvisor &&
            <div className="grid grid-cols-1 gap-8 mt-5">
              {
                advisorBundles?.map?.(bundle =>
                  <AdvisorBundleCard key={bundle.id} bundle={bundle} />
                )
              }
            </div>
          }*/}
        </div>

      </section>


    </div>
  )
}

const mapStateToProps = (state) => {
  const stats = state.payment.stats
  const { currency, plan, org } = { ...state.company?.settings }

  const creditsRequired = stats && stats.activeEmployees > stats.creditBalance
  const creditsWarning = stats && (stats.activeEmployees * 2) > stats.creditBalance

  const modalState = state.payment.modal
  const isNew = state.payment.isNew
  let showModal = modalState;

  const ignoreInsufficientCredits = localStorage.getItem('ignoreInsufficientCredits')

  const isDemo = state.company?.settings?.isDemo

  if (!isDemo && !modalState && !plan && !state.my?.profile?.isAdvisor) {
    showModal = true
  }

  const bundles = state.payment.bundles && _.orderBy(state.payment.bundles?.filter(b =>
      b.isPlan && b.advisor != 'yes' && b.availableTo >= new Date().toISOString() && b.availableFrom <= new Date().toISOString()
  ), ['credits'], ['asc'])?.map(item => {
    const current = item.id == state.company?.settings?.plan
    return {
      ...item,
      current,
      value: item.id,
      label: `${item.name} - ${currency}${item.price}/employee/mo`,
    }
  })

  const advisorBundles = state.payment.bundles && _.orderBy(state.payment.bundles?.filter(b =>
      b.isPlan && b.advisor == 'yes' && b.availableTo >= new Date().toISOString() && b.availableFrom <= new Date().toISOString()
  ), ['credits'], ['asc'])?.map(item => {
    const current = item.id == state.company?.settings?.plan
    return {
      ...item,
      current,
      value: item.id,
      label: `${item.name} - ${currency}${item.price}/employee/mo`,
    }
  })

  // suggested Bundle
  let recommended = false

  if (!recommended && bundles) {
    recommended = bundles[bundles.length]
  }

  if (!org) showModal = false

  return {
    showModal,
    bundles,
    advisorBundles,
    recommended,
    selectedBundle: state.payment.selectedBundle,
    currency,
    isAdvisor: state.my?.profile?.isAdvisor && state.company?.settings?.advisor,
    // advisorUnlimited: state.my?.profile?.advisorUnlimited,
    isDemo,
    isNew
  }
}

const mapDispatchToProps = dispatch => ({
  getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
  closeModal: () => dispatch(PAYMENTACTIONS.showPricingModal(null)),
  selectBundle: (bundle) => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentModal) 
